<template>
  <h1 v-if="!isChangingCampaign" class="tw:font-bold tw:text-xl tw:mb-6 tw:text-xl">
    {{ $t('rc_campaign_type_changes_head') }}
  </h1>
  <p class="tw:mb-6">
    {{ isNetCPA ? $t('rc_campaign_type_changes_text_pay_per_stay') : $t('rc_campaign_type_changes_text_cpa') }}
  </p>
  <div class="tw:flex tw:flex-col tw:md:max-w-[800px] tw:mb-6">
    <div
      v-for="(item, index) in modeInfos"
      :key="index"
      class="icon-element tw:flex tw:items-center tw:mb-4 last:tw:mb-0"
    >
      <div class="tw:pr-2 tw:w-[32px]">
        <BlueCoins v-if="item.icon === 'money'" class="tw:size-6" />
        <Calendar v-else-if="item.icon === 'calendar'" class="tw:size-6" />
        <SettingsBlue v-else-if="item.icon === 'settings-blue'" class="tw:size-6" />
        <Info v-else-if="item.icon === 'info'" class="tw:size-6" />
        <Global v-else-if="item.icon === 'global'" class="tw:size-6" />
      </div>
      <div>
        <h3 class="tw:text-base tw:font-bold tw:text-gray-800">{{ $t(item.head) }}</h3>
        <p class="tw:text-sm tw:text-gray-800">{{ $t(item.text) }}</p>
      </div>
    </div>
  </div>
  <div class="tw:bg-blue-200 tw:text-sm tw:flex tw:flex-row tw:rounded-xl tw:p-4">
    <InformationOutline class="tw:fill-none tw:stroke-gray-800 tw:h-5 tw:w-5 tw:mr-2 tw:mt-[2px]" />
    <p>{{ $t('Once you switch from pay-per-click to pay-per-stay, you won’t be able to revert to pay-per-click.') }}</p>
  </div>
</template>

<script setup>
import BlueCoins from '@/components/icons/BlueCoins.svg?component'
import Calendar from '@/components/icons/Calendar.svg?component'
import SettingsBlue from '@/components/icons/SettingsBlue.svg?component'
import Info from '@/components/icons/Info.svg?component'
import Global from '@/components/icons/Global.svg?component'
import InformationOutline from '@/components/icons/InformationOutline.svg?component'

const props = defineProps({
  isChangingCampaign: Boolean,
  isNetCPA: {
    type: Boolean,
    default: false,
  },
})
const modeInfos = [
  {
    icon: 'money',
    head: 'rc_cpa_change_budget_head',
    text: 'rc_cpa_change_budget_text',
  },
  {
    icon: 'calendar',
    head: 'rc_cpa_change_invoice_head',
    text: props.isNetCPA ? 'rc_pay_per_stay_change_invoice_text' : 'rc_cpa_change_invoice_text',
  },
  {
    icon: 'settings-blue',
    head: 'rc_cpa_change_bidding_head',
    text: 'rc_cpa_change_bidding_text',
  },
  {
    icon: 'info',
    head: 'rc_cpa_change_commission_head',
    text: 'rc_cpa_change_commission_text',
  },
  {
    icon: 'global',
    head: 'rc_cpa_change_markets_head',
    text: 'rc_cpa_change_markets_text',
  },
]
</script>
<style scoped>
.icon-element {
  @media (max-width: theme('screens.md')) {
    flex-basis: 100%;
  }
}
</style>
